<div class="td-wb-form"
     id="td-wb-new-user-exchange-agreements-modal">
  <!-- Modal Header -->
  <td-wb-modal-header>
    <td-wb-modal-header-title modalTitle="tdWb.newUser.signAgreement.AGREEMENTS" />
    <td-wb-modal-header-buttons>
      <td-wb-modal-close-button />
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>
  <!-- Agreement Components Switch -->
  <td-wb-modal-panel>
    @switch (agreement()?.agreementType) {
      @case ('AMEX') {
        <td-wb-amex-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('CEG') {
        <td-wb-ceg-agreement [disabled]="isDisabled()" />
      }
      @case ('ME') {
        <td-wb-me-agreement [disabled]="isDisabled()" />
      }
      @case ('NASDAQ') {
        <td-wb-nasdaq-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('NYSE') {
        <td-wb-nyse-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('OPRA') {
        <td-wb-opra-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('USOTC') {
        <td-wb-usotc-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('CMSPDJ') {
        <td-wb-cme-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('LSEGRU') {
        <td-wb-russel-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('IEX') {
        <td-wb-iex-agreement [disabled]="isDisabled()" [consolidateAgreement]="true" />
      }
      @case ('TDW_TERMS_AND_CONDITIONS') {
        <td-wb-td-agreement [disabled]="isDisabled()" />
      }
      @case ('STOCK_LENDING') {
        <td-wb-fpl-terms-and-conditions />
      }
    }
  </td-wb-modal-panel>
  <!-- Bottom/footer bar -->
  <td-wb-sticky-panel-bottom>
    <td-wb-sticky-panel-bottom-content>
      <td-wb-page-action-panel position="end">
        <button type="button"
                id="td-wb-current-agreements-close-button"
                class="td-wb-consolidated-agreements__button"
                tdWbModalClose
                tdWbButton
                tdWbButtonType="primary">
          <span translate="tdWb.newUser.signAgreement.CLOSE"></span>
        </button>
      </td-wb-page-action-panel>
    </td-wb-sticky-panel-bottom-content>
  </td-wb-sticky-panel-bottom>
</div>
